import { useAtom, useSetAtom } from "jotai";
import { useCallback } from "react";
import { unregisterDataAtom, UnregisterData } from "../state/unregisterAtoms";

export function useUnregisterFlow() {
  const [unregisterData] = useAtom(unregisterDataAtom);
  const setUnregisterData = useSetAtom(unregisterDataAtom);

  const saveUnregisterData = useCallback((data: UnregisterData) => {
    setUnregisterData(data);
  }, [setUnregisterData]);

  const clearUnregisterData = useCallback(() => {
    setUnregisterData(null);
  }, [setUnregisterData]);

  return {
    unregisterData,
    saveUnregisterData,
    clearUnregisterData,
  };
}
